var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.828,12l4.95,4.95-1.414,1.414L8,12l6.364-6.364L15.778,7.05Z",
    transform: "translate(0 0)",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReturn);
export default __webpack_public_path__ + "static/media/icon_return.f408d619141c4cb7c336750c551b7a3a.svg";
export { ForwardRef as ReactComponent };